import { createMMKV } from 'react-native-mmkv';

// MMKV storage instance for the order inbounds (Order Agent) area. Synchronous
// on native; falls back to localStorage on web. Keyed separately from the
// configuration/experience stores so it can be cleared independently.
export const orderInboundsStorage = createMMKV({
  id: 'order-inbounds-storage',
});

export const ORDER_INBOUNDS_STORAGE_KEYS = {
  /** zustand `persist` name for the inbound history list filters. */
  LIST_FILTERS: 'order_inbounds_filters',
};
